import IconFont from 'src/assets/fonts/icon-font.ttf'
import RubikItalic from 'src/assets/fonts/Rubik-Italic.ttf'
import RubikLight from 'src/assets/fonts/Rubik-Light.ttf'
import RubikMedium from 'src/assets/fonts/Rubik-Medium.ttf'
import RubikMediumItalic from 'src/assets/fonts/Rubik-MediumItalic.ttf'
import RubikRegular from 'src/assets/fonts/Rubik-Regular.ttf'
import RubikSemibold from 'src/assets/fonts/Rubik-Semibold.ttf'
import { createGlobalStyle } from 'styled-components'

const GlobalFonts = createGlobalStyle`
  @font-face {
    font-family: 'Rubik-Italic';
    src: url('${RubikItalic}');
    font-weight: normal;
    font-style: normal;
  }

  @font-face {
    font-family: 'Rubik-Medium';
    src: url('${RubikMedium}');
    font-weight: normal;
    font-style: normal;
  }

  @font-face {
    font-family: 'Rubik-MediumItalic';
    src: url('${RubikMediumItalic}');
    font-weight: normal;
    font-style: normal;
  }

  @font-face {
    font-family: 'Rubik-Regular';
    src: url('${RubikRegular}');
    font-weight: normal;
    font-style: normal;
  }

  @font-face {
    font-family: 'Rubik-Semibold';
    src: url('${RubikSemibold}');
    font-weight: normal;
    font-style: normal;
  }

  @font-face {
    font-family: 'Rubik-Light';
    src: url('${RubikLight}');
    font-weight: normal;
    font-style: normal;
  }

  @font-face {
    font-family: 'icon-font';
    src: url('${IconFont}');
    font-weight: normal;
    font-style: normal;
  }
`

export default GlobalFonts
